import { render, staticRenderFns } from "./approveorganization.vue?vue&type=template&id=632b71d8"
import script from "./approveorganization.vue?vue&type=script&lang=js"
export * from "./approveorganization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports